import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import { ProtectedRoute } from "./lib/ProtectedRoute";
import { Navbar } from "./components/Navbar";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import About from "./pages/About";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Dashboard from "./pages/Dashboard";
import UploadSong from "./pages/UploadSong";
import MySongs from "./pages/MySongs";
import Revenue from "./pages/Revenue";
import Copyright from "./pages/Copyright";
import Takedown from "./pages/Takedown";
import Profile from "./pages/Profile";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminSubmissions from "./pages/admin/AdminSubmissions";
import AdminCodes from "./pages/admin/AdminCodes";
import AdminRevenue from "./pages/admin/AdminRevenue";
import AdminYtRevenue from "./pages/admin/AdminYtRevenue";
import AdminCopyright from "./pages/admin/AdminCopyright";
import AdminTakedown from "./pages/admin/AdminTakedown";
import AdminEmailLog from "./pages/admin/AdminEmailLog";
import AdminDspLinks from "./pages/admin/AdminDspLinks";
import AdminReports from "./pages/admin/AdminReports";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminPasswordAudit from "./pages/admin/AdminPasswordAudit";
import AdminBulkImport from "./pages/admin/AdminBulkImport";
import AdminUserDsp from "./pages/admin/AdminUserDsp";
import AdminYoutubeChannels from "./pages/admin/AdminYoutubeChannels";
import AdminStorageManager from "./pages/admin/AdminStorageManager";
import UserDsp from "./pages/UserDsp";
import UserYoutubeChannels from "./pages/UserYoutubeChannels";

import "./App.css";

function Shell({ children }) {
  return (
    <div className="App grain">
      <Navbar />
      <div className="relative z-10">{children}</div>
    </div>
  );
}

function RedirectIfAuthed() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  return <Home />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell>
          <Routes>
            <Route path="/" element={<RedirectIfAuthed />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Navigate to="/login" replace />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />

            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/upload" element={<ProtectedRoute><UploadSong /></ProtectedRoute>} />
            <Route path="/my-songs" element={<ProtectedRoute><MySongs /></ProtectedRoute>} />
            <Route path="/revenue" element={<ProtectedRoute><Revenue /></ProtectedRoute>} />
            <Route path="/copyright" element={<ProtectedRoute><Copyright /></ProtectedRoute>} />
            <Route path="/takedown" element={<ProtectedRoute><Takedown /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute adminOnly><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/users/:userId/bulk-import" element={<ProtectedRoute adminOnly><AdminBulkImport /></ProtectedRoute>} />
            <Route path="/admin/users/:userId/dsp-links" element={<ProtectedRoute adminOnly><AdminUserDsp /></ProtectedRoute>} />
            <Route path="/dsp-links" element={<ProtectedRoute><UserDsp /></ProtectedRoute>} />
            <Route path="/youtube-channels" element={<ProtectedRoute><UserYoutubeChannels /></ProtectedRoute>} />
            <Route path="/admin/youtube-channels" element={<ProtectedRoute adminOnly><AdminYoutubeChannels /></ProtectedRoute>} />
            <Route path="/admin/submissions" element={<ProtectedRoute adminOnly><AdminSubmissions /></ProtectedRoute>} />
            <Route path="/admin/dsp-links" element={<ProtectedRoute adminOnly><AdminDspLinks /></ProtectedRoute>} />
            <Route path="/admin/codes" element={<ProtectedRoute adminOnly><AdminCodes /></ProtectedRoute>} />
            <Route path="/admin/revenue" element={<ProtectedRoute adminOnly><AdminRevenue /></ProtectedRoute>} />
            <Route path="/admin/yt-revenue" element={<ProtectedRoute adminOnly><AdminYtRevenue /></ProtectedRoute>} />
            <Route path="/admin/copyright" element={<ProtectedRoute adminOnly><AdminCopyright /></ProtectedRoute>} />
            <Route path="/admin/takedown" element={<ProtectedRoute adminOnly><AdminTakedown /></ProtectedRoute>} />
            <Route path="/admin/email-log" element={<ProtectedRoute adminOnly><AdminEmailLog /></ProtectedRoute>} />
            <Route path="/admin/reports" element={<ProtectedRoute adminOnly><AdminReports /></ProtectedRoute>} />
            <Route path="/admin/password-audit" element={<ProtectedRoute adminOnly><AdminPasswordAudit /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/storage" element={<ProtectedRoute adminOnly><AdminStorageManager /></ProtectedRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Shell>
        <Toaster position="top-right" theme="dark" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
